<template>
  <div class="uk-background-darkest uk-section uk-section-medium uk-light layout-video" v-if="!$apollo.loading && video">

      <div class="uk-container uk-container-large">

          <ul class="uk-breadcrumb uk-margin-medium-bottom uk-visible@l">
              <li><router-link to="../.." class="text-green"><label>MEDIA</label></router-link></li>
              <li><router-link to="..">Video Gallery</router-link></li>
              <li><span>{{video.title}}</span></li>
          </ul>

          <div class="uk-flex uk-grid-large" uk-grid>
              <div class="uk-width-1-3@l">

                  <!-- <h4 class="text-green uk-margin-remove-bottom" v-if="video.Prize"><label>${{parseInt(video.Prize.Prize).toLocaleString('en-US')}} {{video.Prize.title}}</label></h4> -->

                  <div class="uk-flex uk-grid-divider" uk-grid>
                      <div class="uk-width-2-5@m uk-width-1-1@l">

                          <router-link :to="'/' + video.project.link" v-if="!!video.project && video.project.id>0"><h5 class="text-blue"><b>PROJECT:</b> {{video.project.title}}</h5></router-link>

                          <h1>{{video.title}}</h1>

                      </div>
                      <div class="uk-width-3-5@m uk-width-1-1@l">
                          <!-- <h4 v-if="video.Quote"><em class="text-light-blue">{{video.Quote}}</em></h4> -->
                          <p v-if="video.content">{{video.content}}</p>

                          <router-link v-if="!!video.project && video.project.id>0" :to="video.project.link" class="uk-button theme-button uk-button-primary uk-margin-top">View Project</router-link>
                      </div>
                  </div>

              </div>

               <div class="uk-width-2-3@l uk-width-1-1@m uk-first-column">
                    <div class="flex-video widescreen">
                        <div v-html="video.embedCode"></div>
                    </div>
               </div>
          </div>


      <!-- <div class="uk-section uk-section-medium">
          <div class="uk-container uk-container-small">
              <h1><b>Meet the Hero:</b> {{project.HeroName}}</h1>
              <div v-html="project.StorytellersText"></div>
          </div> -->
      </div>

  </div>
</template>

<script>
// import ProjectCard from '../ProjectCard.vue'
// import FloatingBadge  from '../../components/FloatingBadge.vue'
import gql from 'graphql-tag'

// GraphQL query
const readVideoQuery = gql`
    query($urlSegment: String!) {
      readOneVideo(filter: { urlSegment: { eq: $urlSegment}}){
        id
        content
        title
        link
        embedCode
        project {
            id
            title
            link
        }
      }
    }
`

export default {
    inject: ['state'],
    data() {
        return {
            video: {}
        }
    },
    components: {
        // ProjectCard,
        // FloatingBadge
    },
    apollo: {
        readOneVideo: {
            // GraphQL query
            query: readVideoQuery,
            variables() {
                return {
                    urlSegment: this.$route.params.videoId
                }
            },
            update(data) {
                this.video = data.readOneVideo
                this.state.setMetaTitle(this.video.title)
            }
        }
    }
}
</script>
